import { Card } from "reactstrap";
import { getCountryPerformanceByMarchandId, getStatsAccountByMarchandId } from "../services/merchentApi";
import { useEffect, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { Modal, Spin } from "antd";
import { FormatCurrency } from "../../../../common/format/formatCurrency";
import '../utils/detail.css';
 const CountryPerformance =({id})=>{
       const countryFlags = {
  SN: "https://flagcdn.com/w40/sn.png", 
  CI: "https://flagcdn.com/w40/ci.png", 
  BF: "https://flagcdn.com/w40/bf.png", 
  BJ: "https://flagcdn.com/w40/bj.png", 
  NE: "https://flagcdn.com/w40/ne.png", 
  ML: "https://flagcdn.com/w40/ml.png", 
  GN: "https://flagcdn.com/w40/gn.png", 
  TG: "https://flagcdn.com/w40/tg.png", 
  CM: "https://flagcdn.com/w40/cm.png", 
  CD: "https://flagcdn.com/w40/cd.png" , 
  KE: "https://flagcdn.com/w40/ke.png", 
  NG: "https://flagcdn.com/w40/ng.png",  
  GH: "https://flagcdn.com/w40/gh.png"
};
const [loading, setLoading] = useState(false);
const [loadingStats, setLoadingStats] = useState(false);
const [countryData, setCountryData] = useState([]);
const [statAccount, setStatAccount] = useState([]);
const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedCountry, setSelectedCountry] = useState(null);
const handleOpenModal = (item) => {
  setSelectedCountry(item);
  setIsModalOpen(true);
};

const handleCloseModal = () => {
  setIsModalOpen(false);
  setSelectedCountry(null);
};
useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getCountryPerformanceByMarchandId(id);
    setCountryData(res|| []);
    } catch (e) {
      console.error(e);
      setCountryData([]);
    } finally {
      setLoading(false);
    }
  };
  if (id) fetchData();
}, [id]);
useEffect(() => {
  const fetchStatsData = async () => {
    setLoadingStats(true);
    try {
      const res = await getStatsAccountByMarchandId(id);
   setStatAccount(res || []);
    } catch (e) {
      console.error(e);
      setStatAccount([]);
    } finally {
      setLoadingStats(false);
    }
  };

  if (id) fetchStatsData();
}, [id]);
return (
<div>
 <Card className="mb-3"
  style={{
    padding: "12px",
    border: "1px solid #0000001A",
    borderRadius: "12px",  
    backgroundColor: "#FFFFFF"
    }}
>
   <div className="row g-3">
  
  <div className="col-md-3">
    <Card className="card-business">
      <div className="d-flex justify-content-between align-items-center naming">
        <span>Solde total disponible</span>
      </div>

      <div className="d-flex flex-column gap-1">
          {loadingStats?(
            <Spin size="small"/>
        ):(
              <div className="CAD">{FormatCurrency(statAccount?.availableBalance||0)}</div>
        )}
      </div>
    </Card>
  </div>

  <div className="col-md-3">
    <Card className="card-business">
      <div className="d-flex justify-content-between align-items-center naming">
        <span>En cours de disponibilité</span>
      </div>

      <div className="d-flex flex-column gap-1">
        {loadingStats?(
            <Spin size="small"/>
        ):(
        <div className="CA">{FormatCurrency(statAccount?.balance||0)}</div>
        )
    }
      </div>
    </Card>
  </div>

  <div className="col-md-3">
    <Card className="card-business">
      <div className="d-flex justify-content-between align-items-center naming">
        <span>Versement</span>
      </div>

      <div className="d-flex flex-column gap-1">
         {loadingStats?(
            <Spin size="small"/>
        ):(
        <div className="CA">{FormatCurrency(statAccount?.totalTransferAmount||0)}</div>
        )
        }
      </div>
    </Card>
  </div>
  <div className="col-md-3">
    <Card className="card-business">
      <div className="d-flex justify-content-between align-items-center naming">
        <span>Montant gelé</span>
      </div>
      <div className="d-flex flex-column gap-1">
         {loadingStats?(
            <Spin size="small"/>
        ):(
        <div className="CAG">{FormatCurrency(statAccount?.totalFrozenAmount||0)}</div>
        )}
      </div>
    </Card>
  </div>
</div>
</Card>
<Card style={{
    padding: "12px",
    border: "1px solid #0000001A",
    borderRadius: "12px",  
    backgroundColor: "#FFFFFF"
    }}>
<div className="info-country">Transfert par pays</div>
<div className="mb-3 info-champs">Suivi en temps réel les paiements entrants</div>
<div className="row g-3">
     {loading ? (
  <div style={{ textAlign: "center", padding: "20px" }}>
    ⏳ <Spin/>
  </div>
):!countryData|| countryData.length === 0 ? (
      <div style={{ textAlign: "center", padding: "20px" }}>
        📭 Aucune transfert par pays
      </div>
    ):(
    countryData.map((item, index) => (
    <div className="col-md-4" key={index}>
      <Card className="card-business p-3" onClick={() => handleOpenModal(item)}>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex align-items-center gap-2">
            <img
              src={countryFlags[item.country]}
              alt={item.countryName}
              width="22"
              height="16"
            />
            <span className="info-country">{item.countryName}</span>
          </div>

          <span style={{ fontWeight: 700, color: "#969696", cursor: "pointer" }}>
            <RightOutlined />
        </span>
        </div>
        <div className="mt-2 d-flex flex-column gap-1">
          <div className="d-flex justify-content-between">
            <span className="info-champs">Chiffre d'affaires</span>
            <span className="info-soldes">{FormatCurrency(item.revenue ||0)}</span>
          </div>

          <div className="d-flex justify-content-between">
            <span className="info-champs">Transactions</span>
            <span className="info-soldes">{item.transactionCount}</span>
          </div>

          <div className="d-flex justify-content-between">
            <span className="info-champs">Business</span>
            <span className="info-soldes">{item.businessCount}</span>
          </div>
        </div>
      </Card>
    </div>
    )
  ))}
</div>
</Card>
  <Modal
       open={isModalOpen}
       onCancel={handleCloseModal}
      footer={null}
      centered
      width={500}
      className="modal-detail-payment"
    >
      <h2 className="modal-title">Information du {selectedCountry?.countryName}</h2>

      <div className="payment-details">
        <div className="payment-row">
          <span className="label">Pays</span>
          <span className="value">{selectedCountry?.countryName}</span>
      
  </div>

        <div className="payment-row">
          <span className="label">Revenu</span>
          <span className="value">{FormatCurrency(selectedCountry?.revenue ||0)}</span>
        </div>

        <div className="payment-row">
          <span className="label">Nombre de Transactions</span>
          <span className="value">{selectedCountry?.transactionCount}</span>
        </div>

        <div className="payment-row">
          <span className="label">Nombre de Business</span>
          <span className="value">{selectedCountry?.businessCount}</span>
        </div>

        <div className="payment-row">
          <span className="label">Sode encaissé</span>
          <span className="value">{FormatCurrency(selectedCountry?.balance||0)}</span>
        </div>
      <div className="payment-row">
          <span className="label">Solde disponible </span>
          <span className="value">{FormatCurrency(selectedCountry?.availableBalance||0)}</span>
        </div>
        <div className="payment-row">
          <span className="label">Montant gélé</span>
          <span className="value">{FormatCurrency(selectedCountry?.totalTransfert||0)}</span>
        </div>
	<div className="payment-row">
          <span className="label">Montant total transfert</span>
          <span className="value">{FormatCurrency(selectedCountry?.totalTransfert||0)}</span>
        </div>
       
      </div>
    </Modal>
</div>
)
 }
 export default CountryPerformance; 